var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindy = function SvgWindy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 5a1 1 0 0 0-.746.334A1 1 0 1 1 8.764 4 3 3 0 1 1 11 9H2a1 1 0 0 1 0-2h9a1 1 0 1 0 0-2m8 2c-.592 0-1.123.256-1.49.667a1 1 0 0 1-1.491-1.334A4 4 0 1 1 19 13H2a1 1 0 1 1 0-2h17a2 2 0 1 0 0-4M1 16a1 1 0 0 1 1-1h12a3 3 0 1 1-2.236 5 1 1 0 1 1 1.49-1.334A1 1 0 1 0 14 17H2a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgWindy;